import Typography from 'components/commercetools-ui/atoms/typography';
import Button from 'components/commercetools-ui/atoms/button';
import AuthForm from '../layouts/auth-form';
import { useState } from 'react';
import { sdk } from 'sdk';

const PasswordResetConfirm = ({
  email,
  handleOnClosePopup,
  setShowConfirmationPopup,
  handleModalCancel,
  authProps,
}: any) => {
  const extensions = sdk.composableCommerce;
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState<string>('');

  const handleConfirm = () => {
    setShowConfirmationPopup(false);
    handleOnClosePopup();
  };

  const handleDidNotReciveEmail = async () => {
    if (email) {
      try {
        setLoading(true);
        const responseBody: any = await extensions.account.ResetPasswordAuth0(
          JSON.stringify({ email: email.toLowerCase() }),
        );
        if (responseBody?.data?.statusCode === 200) {
          setLoading(false);
          setSuccess('Reset password email sent again, please check.');
          setTimeout(() => {
            setSuccess('');
          }, 2000);
        } else {
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        console.error('Reset Pasword Error:', error);
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className="bg-Neutral-500">
      <AuthForm
        {...authProps}
        headTitle="Log in or Sign up"
        title="Reset Password"
        buttonLabel="Return to login"
        onSubmit={handleConfirm}
        handleModalCancel={handleModalCancel}
        resetCallback={() => {}}
        success={success ? success : ''}
      >
        <Typography>{`We have sent an email to ${email}  with password reset instructions.`}</Typography>
      </AuthForm>
      <Button
        variant={'ghost'}
        onClick={handleDidNotReciveEmail}
        disabled={loading}
        loading={loading}
        className="relative !my-2 h-44 w-full cursor-pointer rounded-none  border-2 border-black bg-transparent !px-25 !py-13 text-center text-14 text-black"
      >
        {"Didn't receive the email"}
      </Button>
    </div>
  );
};

export default PasswordResetConfirm;
